import { createAction } from 'redux-actions';

export const fetchAllClients = createAction("FETCH_ALL_CLIENTS");
export const fetchAllClientsSuccess = createAction("FETCH_ALL_CLIENTS_SUCCESS");
export const fetchAllClientsFailure = createAction("FETCH_ALL_CLIENTS_FAILURE");

export const deleteClients = createAction("DELETE_CLIENTS");
export const deleteClientsSuccess = createAction("DELETE_CLIENTS_SUCCESS");
export const deleteClientsFailure = createAction("DELETE_CLIENTS_FAILURE");

export const toggleClientsEnabled = createAction("TOGGLE_CLIENTS_ENABLED");
export const toggleClientsEnabledSuccess = createAction("TOGGLE_CLIENTS_ENABLED_SUCCESS");
export const toggleClientsEnabledFailure = createAction("TOGGLE_CLIENTS_ENABLED_FAILURE");
